module.exports = __webpack_public_path__ + "img/cold.bc093160.svg";